import { cellRenderPopupActM15 } from '../PopupActMVP/functionPopupAct';
import { cellRenderParseData, cellRenderStatusAct } from '../../utils/functions';

const columnDataM15 = [
  {
    dataField: 'm15',
    caption: 'М-15',
    cellRender: cellRenderPopupActM15,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'm15NumId',
    caption: 'id М-15',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'm15DocStatus',
    caption: 'id М-15 Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'm15Date',
    caption: 'Дата М-15',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'm15DocStatusDescr',
    caption: 'Статус акта М-15',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  }
];

export default columnDataM15;
